﻿/**
* DevExpress Dashboard (_tab-page-properties-composer.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = require("../../../model");
var _interactivity_options_1 = require("../../../model/items/options/metadata/_interactivity-options");
var _dashboard_tab_page_1 = require("../../../model/items/tab-container-item/metadata/_dashboard-tab-page");
var _base_metadata_1 = require("../../../model/metadata/_base-metadata");
var _object_properties_wrapper_1 = require("../../form-adapter/_object-properties-wrapper");
var _accordion_tab_1 = require("../../properties-controller/_accordion-tab");
var _base_properties_composer_1 = require("./_base-properties-composer");
var DashboardTabPagePropertiesComposer = (function (_super) {
    __extends(DashboardTabPagePropertiesComposer, _super);
    function DashboardTabPagePropertiesComposer(customizeHandler) {
        return _super.call(this, customizeHandler) || this;
    }
    DashboardTabPagePropertiesComposer.prototype._composeTabsCore = function (tabPage, args) {
        var objectPropertiesWrapper = new _object_properties_wrapper_1.ObjectPropertiesWrapper({
            model: tabPage,
            properties: [
                _base_metadata_1.name_ViewModel,
                _dashboard_tab_page_1.showItemAsTabPage,
                {
                    container: model_1._tabItemInteractivityOptions,
                    properties: [
                        _interactivity_options_1.isMasterFilterDefaultTrue,
                        _interactivity_options_1.ignoreMasterFiltersDefaultFalse
                    ]
                }
            ]
        });
        return [new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.Common, 'DashboardWebStringId.Options', objectPropertiesWrapper)];
    };
    return DashboardTabPagePropertiesComposer;
}(_base_properties_composer_1.DashboardItemPropertiesComposer));
exports.DashboardTabPagePropertiesComposer = DashboardTabPagePropertiesComposer;
